import router from '../../router'
import { Constants } from '../../constants'
import { mixin as clickaway } from 'vue-clickaway'
import { TokenService } from '../../services/token.service'
import { KeycloakService } from '../../services/keycloak.service'

export default {
    name: 'NavigationBar',
    mixins: [ clickaway ],

    props: {
        selected: String
    },

    data() {
        return {
            tabsClass: 'hidden',
            menuClass: '',
            closeClass: 'hidden'
        }
    },

    computed: {
        showSettings() {
            return KeycloakService.isSuperUser() || KeycloakService.isWarehouseManager()
        },

        showDocks() {
            return !KeycloakService.isBookingAgent()
        }
    },

    methods: {
        logoutButtonPressed() {
            TokenService.invalidateToken()

            setTimeout(() => {
                KeycloakService.logout()
            }, 1);
        },

        selectTab(target) {
            return this.selected == target ? 'navigation-bar-tab-selected' : ''
        },

        hideTabs() {
            this.tabsClass = 'hidden'
            this.menuClass = ''
            this.closeClass = 'hidden'
        },

        showTabs() {
            this.tabsClass = ''
            this.menuClass = 'hidden'
            this.closeClass = ''
        },

        getProfileUrl() {
            return `${process.env.VUE_APP_KEYCLOAK_AUTH_URL}/realms/${process.env.VUE_APP_KEYCLOAK_REALM}/account`
        }
    }
}
